export const initialMessages = [
  {
    id: "m1",
    role: "user",
    text: "búscame el último vídeo de n8n que guardé",
  },
  {
    id: "m2",
    role: "assistant",
    toolCall: 'buscar_contenido(tema:"n8n", orden:"fecha")',
    text: "El más reciente sobre n8n es este, guardado hace 2 días:",
    itemRefId: "c1",
  },
];
